module.exports = "/images/ic-girl-02.jpg?904537fd202b3dc67a29a5069796bcc0";